"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cell = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Cell = ({ children, gutter, stickyRight, column, active, disabled, className, }) => {
    return (react_1.default.createElement("div", { className: classnames_1.default('dsg-cell', gutter && 'dsg-cell-gutter', disabled && 'dsg-cell-disabled', gutter && active && 'dsg-cell-gutter-active', stickyRight && 'dsg-cell-sticky-right', className), style: {
            flex: String(column.width),
            minWidth: column.minWidth,
            maxWidth: column.maxWidth,
        } }, children));
};
exports.Cell = Cell;
//# sourceMappingURL=Cell.js.map